import { render, staticRenderFns } from "./moveTotal.vue?vue&type=template&id=70e530f0&scoped=true&"
import script from "./moveTotal.vue?vue&type=script&lang=js&"
export * from "./moveTotal.vue?vue&type=script&lang=js&"
import style0 from "./moveTotal.vue?vue&type=style&index=0&id=70e530f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e530f0",
  null
  
)

export default component.exports